<div class="contact-form">
  <div class="title text-center">Get in touch</div>
  <div class="caption text-center">Feel free to contact us and we will get in touch with you</div>

  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    <div class="">

      <div class="d-flex flex-row justify-content-between">
        <div class="wrap-form-control w-50 p-2">
          <label for="name" class="form-label">Full Name</label>
          <input formControlName="name" type="name" id="name" class="form-control" />
        </div>


        <div class="wrap-form-control w-50 p-2">
          <label for="phone" class="form-label">Phone Number</label>
          <input formControlName="phone" type="phone" id="phone" class="form-control " />
        </div>
      </div>

      <div class="wrap-form-control p-2">
        <label for="email" class="form-label">Email</label>
        <input formControlName="email" type="email" id="email"
        class="form-control" />
      </div>

      <div class="property-select p-2" *ngIf="!propertyId">
        <div>
          <label for="phone" class="form-label">Hotel</label>
          <ng-select formControlName="propertyId" [items]="properties" bindLabel="name" bindValue="id" groupBy="state"
          placeholder="Select a location" [searchFn]="propertySearchFn">
          <ng-template ng-optgroup-tmp let-item="item">
            {{item.state || 'Others'}}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{item.name}} <br />
            <small><strong>{{item.city}}</strong></small>
          </ng-template>
        </ng-select>
        </div>
      </div>

      <div class="message p-2">
        <label class="form-label">Message</label>
        <textarea formControlName="description" name="message" class="form-control"></textarea>
      </div>

      <div class="d-grid gap-2 p-2">
        <button class="btn btn-primary" [disabled]="!contactForm.valid" type="submit">Send</button>
      </div>

      <div class="alert alert-success" role="alert" *ngIf="showSuccess" status="success">
        Your message has been sent Successfully!
      </div>

    </div>
  </form>
</div>